import { registerSchema } from '@erikdakoda/utils/schemaRegistry';

import { PipelinePlanReviewSchema } from './PipelinePlanReviewSchema';
import { PipelineTriageSchema } from './PipelineTriageSchema';
import { SentryTriageSchema } from './SentryTriageSchema';

/**
 * Registers pipeline structured-output schemas (`Bot.outputSchema` ids).
 * Always re-registers (HMR-safe) so schema edits replace the prior Zod contract.
 */
export function seedPipelineOutputSchemas(): void {
  registerSchema({
    app: 'forge',
    name: 'pipeline-triage',
    version: 1,
    zodSchema: PipelineTriageSchema,
    format: {},
  });
  registerSchema({
    app: 'forge',
    name: 'pipeline-plan-review',
    version: 1,
    zodSchema: PipelinePlanReviewSchema,
    format: {},
  });
}

/**
 * Registers the Sentry triage structured-output schema (`Bot.outputSchema` id).
 * Always re-registers (HMR-safe) so schema edits replace the prior Zod contract.
 */
export function seedSentryOutputSchemas(): void {
  registerSchema({
    app: 'forge',
    name: 'sentry-triage',
    version: 1,
    zodSchema: SentryTriageSchema,
    format: {},
  });
}

/**
 * Registers all Forge structured-output schemas for app init.
 * Safe to call from any app without pulling pipeline or sentry packages.
 * Lives in `@erikdakoda/schema` so apps can seed without heavy domain imports.
 */
export function seedForgeOutputSchemas(): void {
  seedPipelineOutputSchemas();
  seedSentryOutputSchemas();
}
